import {AuditService} from "../PA.Core/Security/AuditService";
import {BaselineBO} from "./BaselineBO";
import {auditFieldFK, AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import { esWB_Baseline, esWB_Customer, esWB_Product_Group } from "../PA.Core/PAdbSchema";

export class BaselineBOAudit {

    static async BaselineAuditBO(BaselineBO: BaselineBO): Promise<AuditService> {

        const self = BaselineBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference(esWB_Baseline, self.drWB_Baseline.cif.WB_BASELINE_ID)

        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        const baselineParams: IAuditField [] = [
            {fieldName: "BASELINE_NAME",        realName: "Name", bAllMsg: true }, //create
            {fieldName: "BASELINE_ID",          realName: "ID", bAllMsg: true }, //create
            {fieldName: "BASELINE_TYPE_ID",     realName: "Baseline Type", domainId: "Baseline_Type" },
            {fieldName: "MANUAL_IND",           realName: "Manual" },
            {fieldName: "WB_BUSINESSUNIT_ID",   realName: "Business Unit" },
            {fieldName: "BASELINE_SOURCE_ID",   realName: "Business Source" },
            {fieldName: "WB_SCHEDULE_ID",       realName: "Schedule" },
            {fieldName: "WB_PARTITION_ID",      realName: "Partition" },
            {fieldName: "WB_CUSTH_ID",          realName: "Customer Hierarchy", ...auditFieldFK.customerHierarchy },
            {fieldName: "CUSTOMER_LEVEL",       realName: "Customer Level" },
            {fieldName: "WB_PRDH_ID",           realName: "Product Hierarchy",  ...auditFieldFK.productHierarchy },
            {fieldName: "PRODUCT_TYPE",         realName: "Product Type" },
            {fieldName: "PRODUCT_LEVEL",        realName: "Product Level" },
            {fieldName: "BOM_DECOMP_IND",       realName: "Decompose Bom" },
            {fieldName: "WB_PERIODH_ID",        realName: "Period Hierarchy",  bAllMsg: true },
            {fieldName: "WB_PERIODM_ID",        realName: "Period Type" },
            {fieldName: "WB_PERIOD_ID",         realName: "Period",             ...auditFieldFK.period },
            {fieldName: "UOM_ID",               realName: "Unit of Measure" },
            {fieldName: "HIST_DATATHRU_DT",     realName: "History Data Thru Date" },
            {fieldName: "REFRESH_CUTOFF_DAYS",  realName: "Refresh Cutoff Days" }
        ]

        await AuditUtils.logRecord(auditService, self.WB_Baseline, baselineParams, {
            objectName: 'Baseline',
            deletedKeys: deleteKeys
        })

        // Partition
        const partitionParams: IAuditField [] = [
            {fieldName: "WB_PARTITION_ID",      realName: "Partition ID" },
            {fieldName: "WB_PARTITIONR_ID",     realName: "PartitionR ID" },
            {fieldName: "WB_CUST_ID",           realName: "Customer",   fkMapper: esWB_Customer, fkMapperNameField: "CUSTOMER_NAME", fkMapperIdField: "CUSTOMER_ID", bAllMsg: true },
            {fieldName: "WB_PRDGRP_ID",         realName: "Product Group", fkMapper: esWB_Product_Group, fkMapperNameField: "PRODUCT_GROUP_NAME", fkMapperIdField:"WB_PRDGRP_ID", bAllMsg: true },
            {fieldName: "WB_PERIOD_ID",         realName: "Period",     ...auditFieldFK.period },
        ]

        for (const aPartitionRRow of self.partitionBO.drWB_Partition.WB_PartitionRRows) {
            await AuditUtils.logRecord(auditService, aPartitionRRow, partitionParams, {
                objectName: 'Baseline Partition',
                deletedKeys: deleteKeys,
            })
        }

        return auditService
    }

}
